export class EFormAttachment {
    ID: number = null;
    Name = '';
    OriginalFileName = '';
    FileDataBase64 = '';
    FileType = '';
    MIMEType = '';
    FileExtension = '';
    AddedBy: number = null;
    AddedOn: Date = null;
    LastUpBy: number = null;
    LastUpOn: Date = null;
    DelStatus = false;
   }